import React from 'react';

import { BaseModal } from '../../../../components/BaseModal';

interface RemoveTeamMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  memberName: string;
  isRemoving: boolean;
}

export const RemoveTeamMemberModal: React.FC<RemoveTeamMemberModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  memberName,
  isRemoving,
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title="Are you sure you want to remove this team member from the Buyer?"
      isDismissable={!isRemoving}
      hideCloseButton
      footerContent={{
        onCancel: onClose,
        onConfirm,
        isLoading: isRemoving,
        isDisabled: isRemoving,
        isDestructive: true,
        confirmText: isRemoving ? 'REMOVING...' : 'REMOVE',
        cancelText: 'CANCEL',
      }}
    >
      <p className="text-default-500 text-sm">
        <span className="font-medium text-foreground">{memberName}</span> will
        be removed from all chats with suppliers in this entity.
      </p>
    </BaseModal>
  );
};
